// src/data/companyData.js

// Import assets if they are local and managed by the build process
import logoImage from "../images/2.png"; // Import your logo image

// Import Icons (Consider moving icon imports to the components that use them)
import { Building, BrainCircuit, BarChart, Database, Layers, Briefcase } from 'lucide-react';

export const companyData = {
  name: "BlackPeak Solutions",
  // Use the imported logo variable
  logoUrl: logoImage,
  hero: {
    title: "Shaping the Future of Business with Cutting-Edge Data and Technology Solutions.",
    subtext: "From insight to impact—empowering industries to make smarter decisions and achieve transformative results.",
    // Using the Pexels URL provided by the user.
    backgroundImageUrl: "https://images.pexels.com/photos/6801648/pexels-photo-6801648.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
  },
  capabilities: [
    { category: "Real Estate", skills: ["Property trends, pricing analytics, and neighborhood insights"], icon: Building },
    { category: "Technology", skills: ["AI-ready datasets for training models and optimizing systems"], icon: BrainCircuit },
    { category: "Finance", skills: ["Economic indicators, risk modeling datasets, and market forecasting"], icon: BarChart },
  ],
  productsServices: {
    datasets: {
      title: "Data Sets",
      description: "Unlock the power of high-quality, actionable data.",
      icon: Database,
      items: [
        "Real Estate: Property trends, pricing analytics, and neighborhood insights.",
        "Finance: Economic indicators, risk modeling datasets, and market forecasting.",
        "Technology: AI-ready datasets for training models and optimizing systems."
      ],
      features: [
        "Accuracy: Curated and verified datasets, updated regularly.",
        "Customization: Tailored datasets for unique business needs.",
        "Easy Integration: Ready-to-use formats (CSV, JSON, API)."
      ]
    },
    saas: {
      title: "SaaS Solutions",
      description: "Scalable software designed to enhance business performance.",
      icon: Layers,
      items: [
        "InsightFlow: Real-time analytics with customizable dashboards for monitoring KPIs.",
        "DataBridge: Seamless integration of datasets into existing workflows.",
        "MarketPulse: Predictive analytics to identify emerging trends and opportunities."
      ],
      features: [
        "AI-powered analytics for smarter decision-making.",
        "Secure cloud-based architecture with multi-level access controls.",
        "Scalable tools to grow with your business."
      ]
    },
    consulting: {
      title: "Consulting Services",
      description: "Expert guidance to overcome challenges and unlock growth.",
      icon: Briefcase,
      items: [ // Using nested structure for clarity
        {
          title: "Tech Consulting:",
          points: [
            "Process automation for efficiency.",
            "Cloud migration for scalability.",
            "System optimization to maximize ROI."
          ]
        },
        {
          title: "Financial Consulting:",
          points: [
            "Advanced data modeling for risk assessment.",
            "Strategic financial planning to improve profitability.",
            "Market analysis to uncover investment opportunities."
          ]
        }
      ],
      features: [] // No separate features list provided for consulting
    }
  },
  about: {
    content: `BlackPeak Solutions is a global leader in data-driven innovation, delivering reliable insights and scalable technology solutions to businesses of all sizes. Founded by a team of technologists and financial strategists, our mission is to bridge the gap between raw data and actionable insights, empowering organizations to thrive in today’s competitive landscape.`
  },
  contactEmail: "contact@blackpeaksolutions.co"
};

